@use '../../../assets/styles/utilities.scss';

:host {
  display: block;
}

.idle-timer-btn {
  border-radius: 20px;
  background-color: #3282f0;
  &:hover {
    background-color: #2871d3;
  }
  &:active {
    background-color: #1f5fb3;
  }
}
